import { PropsWithChildren, useEffect } from 'react';

import { useAppDispatch } from '@/hooks/redux';

import { resetOperationData } from '@/redux/operation';
import { resetUserData } from '@/redux/user-data';

export function PublicPage({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetUserData());
    dispatch(resetOperationData());
  }, [dispatch]);

  return children;
}
